import { TypedTranslation } from '../../../../translation/types';

enum CarouselTextKeys {
	SCROLL_TO_LEFT = 'SPORTSBOOK_CAROUSEL_SCROLL_TO_LEFT',
	SCROLL_TO_RIGHT = 'SPORTSBOOK_CAROUSEL_SCROLL_TO_RIGHT'
}

export type CarouselTranslations = Readonly<TypedTranslation<typeof CarouselTextKeys>>;

export default CarouselTextKeys;
